import i18n from 'i18next'
interface Translations {
    [key: string]: string
}
export const getTranslationsForAllLanguages = (key: string) => {
    const { languages } = i18n
    const translations: Translations = {}

    languages.forEach((lng: string) => {
        translations[lng] = i18n.getFixedT(lng)(key)
    })

    return translations
}
